import React from 'react';
import Styled from './styles';

const Container = ({ children }) => (
  <Styled.Container>{children}</Styled.Container>
);

export default Container;
